import Link from "next/link";
import idCreator from "../../utils/idCreator";
import styles from './BreadCrumb.module.scss';

const Breadcrumb = ({ breadCrumbLinks, redirectUrl }) => (
    <ul className="list-inline">
      {
        breadCrumbLinks.map((crumb) => {
          const { label, url } = crumb.fields;
          const regex = new RegExp("(?=.)\/" + redirectUrl + "+?$", 'ig');
          const active = url.match(regex);
          const linkDecoration = active ? styles.crumbActive : styles.crumb;

          return (
            <li key={idCreator(label)} className="list-inline-item breadcrumbs mr-6 my-3">
              <Link href={url} className={linkDecoration}>
                {label}
              </Link>
            </li>
          );
        })
      }
    </ul>
);

export default Breadcrumb;
